import moment from 'moment';
import * as React from 'react';
import { AppBarNavigationItemPortalDestinationId } from '../../components/AppBar';
import { NavigationBreadcrumbsBar } from '../../components/NavigationBreadcrumbsBar';
import { Portal } from '../../components/Portal';
import { INavigationItemProps } from '../MainContainer';
import './styles.less';

export class BuildInfo extends React.Component<INavigationItemProps> {
	public componentDidMount() {
		fetch('/static/build-info.json')?.then(async res => {
			console.log(await res.json());
		});
	}

	public render() {
		return (
			<div className={`build-info ${this.props.routeContainerClassName || ''}`}>
				<Portal destination={AppBarNavigationItemPortalDestinationId}>
					<NavigationBreadcrumbsBar currentLocationName='Build Info' />
				</Portal>
				<div className='build-info-date'>{`Date:\t${moment(__BUILD_TIME__).format('hh:mm:ss A\tMM/DD/YYYY')}`}</div>
				<div className='build-info-hash'>{`Hash:\t${__BUILD_HASH__}`}</div>
			</div>
		);
	}
}
